import React from 'react'

import { useDispatch } from 'react-redux'

import { CLEAR_FILTER_FIELDS } from '../../../redux_toolkit/@types/action.types'
import { FilterActionTypes } from '../../../redux_toolkit/V3/Filter'
import { getBreadCrumbs, setBreadCrumbRoutes } from '../../../helpers/Util'
import { useNavigate } from 'react-router-dom'
import Image from '../../../common/Image'

const FourItemCollection = ({ collections }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const handleRoute = (collection) => {
        dispatch(FilterActionTypes[CLEAR_FILTER_FIELDS]())
        let newRoute = `/collections/${collection.id}`
        let visitingRoutes = getBreadCrumbs()
        visitingRoutes.push({
            key: newRoute,
            value: collection.name
        })

        setBreadCrumbRoutes(visitingRoutes)
        navigate(newRoute)
    }

    const renderCollections = () => {
        return collections?.map((item, i) => {
            return (
                <div
                    className={`collection-card ${
                        item?.coverDocumentResponse?.docUrl ? 'cover-photo' : ''
                    }`}
                    key={`collection_card_four_${i}`}
                >
                    <div
                        className='four-item-image'
                        onClick={() => handleRoute(item)}
                    >
                        {!item?.coverDocumentResponse?.docUrl && (
                            <>
                                <div className='single-item'>
                                    {item?.documentResponseList?.[0] && (
                                        <Image
                                            src={
                                                item?.documentResponseList?.[0]
                                                    ?.docUrl
                                            }
                                            alt='style'
                                            isStatic={false}
                                        />
                                    )}
                                </div>
                                <div className='single-item'>
                                    {item?.documentResponseList?.[1] && (
                                        <Image
                                            src={
                                                item?.documentResponseList?.[1]
                                                    ?.docUrl
                                            }
                                            alt='style'
                                            isStatic={false}
                                        />
                                    )}
                                </div>
                                <div className='single-item'>
                                    {item?.documentResponseList?.[2] && (
                                        <Image
                                            src={
                                                item?.documentResponseList?.[2]
                                                    ?.docUrl
                                            }
                                            alt='style'
                                            isStatic={false}
                                        />
                                    )}
                                </div>
                                <div className='single-item'>
                                    {item?.documentResponseList?.[3] && (
                                        <Image
                                            src={
                                                item?.documentResponseList?.[3]
                                                    ?.docUrl
                                            }
                                            alt='style'
                                            isStatic={false}
                                        />
                                    )}
                                </div>
                            </>
                        )}
                        {item?.coverDocumentResponse?.docUrl && (
                            <>
                                <div className='single-item'>
                                    <Image
                                        src={
                                            item?.coverDocumentResponse?.docUrl
                                        }
                                        alt='style'
                                        isStatic={false}
                                    />
                                </div>
                            </>
                        )}
                    </div>

                    <div className='collection-content d-flex justify-between items-center'>
                        <div onClick={() => handleRoute(item)}>
                            <h3 className='collection-title'>{item?.name}</h3>
                            <div className='details-info'>
                                <ul className='common-list-component'>
                                    {item?.season && <li>{item?.season}</li>}
                                    {item?.numOfDesign && (
                                        <li>
                                            {item.numOfDesign}{' '}
                                            {item.numOfDesign > 1
                                                ? 'Styles'
                                                : 'Style'}
                                        </li>
                                    )}
                                    {item?.ownerName && (
                                        <li>{item.ownerName}</li>
                                    )}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            )
        })
    }

    return (
        <div className={'collection-four-row-item mb-6 4xl:mb-10'}>
            {renderCollections()}
        </div>
    )
}

export default FourItemCollection
